module.exports = __webpack_public_path__ + "img/jt.c51639f3.png";